module.exports = __webpack_public_path__ + "img/hezuo.e5d290fa.png";